

















import { computed, defineComponent, toRefs } from '@vue/composition-api';
import { genDestinationUrlTypes } from '@tt4b/ttam-enums';

const name = 'ttam-destination-type-options';
export default defineComponent({
  name,
  props: {
    value: {
      type: String,
      default: genDestinationUrlTypes().WEB_SITE.name,
    },
    options: {
      type: Array,
      default: () => genDestinationUrlTypes(),
    },
  },
  setup(props, { emit }) {
    const { value } = toRefs(props);
    const _value = computed({
      get() {
        return value.value;
      },
      set(val) {
        emit('input', val);
      },
    });
    return {
      name,
      _value,
      genDestinationUrlTypes,
    };
  },
});
